import React from "react";
import { useTranslation } from "react-i18next";
import { ShieldOff } from "lucide-react";
import { Card, CardContent } from "../ui/card";

interface ProtectedPageRouteProps {
  pageIdentifier: string;
  userPermissions: string[];
  children: React.ReactNode;
}

const ProtectedPageRoute: React.FC<ProtectedPageRouteProps> = ({
  pageIdentifier,
  userPermissions,
  children,
}) => {
  const { t } = useTranslation();
  const hasAccess = userPermissions.includes(pageIdentifier);

  if (!hasAccess) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Card className="max-w-md">
          <CardContent className="flex flex-col items-center justify-center p-12">
            <ShieldOff className="h-16 w-16 text-destructive mb-4" />
            <h2 className="text-2xl font-semibold mb-2">
              {t("common_page_not_available", "Page Not Available")}
            </h2>
            <p className="text-muted-foreground text-center">
              {t(
                "common_page_not_available_description",
                "This page has been disabled by your hotel administrator or you don't have permission to access it."
              )}
            </p>
            <button
              onClick={() => window.history.back()}
              className="mt-6 px-4 py-2 bg-primary text-primary-foreground rounded hover:bg-primary/90"
            >
              {t("common_go_back", "Go Back")}
            </button>
          </CardContent>
        </Card>
      </div>
    );
  }

  return <>{children}</>;
};

export default ProtectedPageRoute;
